const requiredSettings = ['frontendUrl', 'mannhartWebsite', 'termsAndConditions', 'privacyPolicy', 'releaseNotes']

const requiredApiUrls = [
  'authenticationService', 'userEndpoint', 'releaseNotesEndpoint', 'plansEndpoint', 'planOwnerEndpoint',
  'projectsEndpoint', 'deliveryAddressEndpoint', 'billingAddressEndpoint', 'projectStatusEndpoint',
  'planPdfDownload', 'detailsEndpoint', 'armouringDataEndpoint', 'armouringDocumentsEndpoint',
  'vaultElementInfoEndpoint',
]

export let settings

export const setSettings = candidate => {
  settings = validateSettings(candidate)
  return settings
}

const isNonEmptyString = value => typeof value === 'string' && value.trim().length > 0

const validateSettings = candidate => {
  if (!candidate || typeof candidate !== 'object') {
    throw new Error('Die Settings-Datei enthält kein JSON-Objekt.')
  }

  const missingSettings = requiredSettings.filter(key => !isNonEmptyString(candidate[key]))
  const missingApiUrls = requiredApiUrls.filter(key => !candidate.apiUrls || !isNonEmptyString(candidate.apiUrls[key]))
  if (missingSettings.length || missingApiUrls.length) {
    const missing = [...missingSettings, ...missingApiUrls.map(key => `apiUrls.${key}`)]
    throw new Error(`Die Settings-Datei enthält fehlende oder ungültige Werte: ${missing.join(', ')}`)
  }

  return Object.freeze({...candidate, apiUrls: Object.freeze({...candidate.apiUrls})})
}

export const loadSettings = async () => {
  const publicUrl = process.env.PUBLIC_URL || ''
  const response = await fetch(`${publicUrl}/assets/settings.json`, {cache: 'no-store'})
  if (!response.ok) {
    throw new Error(`Die Settings-Datei konnte nicht geladen werden (${response.status}).`)
  }

  let candidate
  try {
    candidate = await response.json()
  } catch {
    throw new Error('Die Settings-Datei enthält ungültiges JSON.')
  }

  return setSettings(candidate)
}
